import { render, staticRenderFns } from "./EditTopic.vue?vue&type=template&id=3ae46462&scoped=true"
import script from "./EditTopic.vue?vue&type=script&lang=js"
export * from "./EditTopic.vue?vue&type=script&lang=js"
import style0 from "./EditTopic.vue?vue&type=style&index=0&id=3ae46462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae46462",
  null
  
)

export default component.exports